import CaseAssignmentModal, {
    type CaseAssignmentFields,
} from "@/components/Forms/SubForms/CaseAssignmentModal.tsx";
import { type NewCase, useAddCase } from "@/mutations/useAddCase.tsx";
import { getErrorMessage } from "@/utils/api.ts";
import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { type ReactNode, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
    personUUID: string;
};

const AddCaseDialog = ({ personUUID }: Props): ReactNode => {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const addCaseToPersonMutation = useAddCase(personUUID);

    const handleOpenModal = useCallback(() => {
        setModalOpen(true);
    }, []);

    const handleCloseModal = useCallback(() => {
        setModalOpen(false);
    }, []);

    const handleSubmit = useCallback(
        (assignments: CaseAssignmentFields) => {
            addCaseToPersonMutation.mutate(
                { assignments },
                {
                    onSuccess: (data: NewCase) => {
                        enqueueSnackbar("Case added.", { variant: "success" });
                        setModalOpen(false);
                        navigate(`/case-detail/${data.caseID}`);
                    },
                    onError: (error) => {
                        enqueueSnackbar("Error: Add Case failed.", { variant: "error" });
                        console.info("error", getErrorMessage(error));
                    },
                },
            );
        },
        [addCaseToPersonMutation, navigate],
    );

    return (
        <>
            <Button
                variant={"contained"}
                sx={{
                    ml: 2,
                    minWidth: "120px",
                }}
                onClick={handleOpenModal}
            >
                New Case
            </Button>
            <CaseAssignmentModal
                open={modalOpen}
                onClose={handleCloseModal}
                onSubmit={handleSubmit}
                isSubmitting={addCaseToPersonMutation.isPending}
            />
        </>
    );
};

export default AddCaseDialog;
